import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../utils/routes';
import { useDispatch, useSelector } from 'react-redux';
import { AppStore } from '../../store/applicationState';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { ConfigurationsActions } from '../../store/configurations/actions';
import { MainMonthForm } from '../../components/MainInMonth/MainMonthForm';
import { GetOneMainInMonth } from '../../store/mainInMonth/actions';

export const CoppyMonthMain: React.FC = () => {
  const { MainInMonth } = useSelector((store: AppStore) => store);
  const { search } = useLocation();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  React.useEffect(() => {
    const query = new URLSearchParams(search);
    const siteId = query.get('site_id');
    if (siteId) {
      dispatch(ConfigurationsActions.setSiteId(Number(siteId)));
    }
  }, [dispatch, search]);

  React.useEffect(() => {
    if (id) {
      dispatch(GetOneMainInMonth.request({ id: Number(id) }));
    }
  }, [dispatch, id]);

  if (!MainInMonth.current)
    return (
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100vh'}>
        <CircularProgress color='secondary' />
      </Box>
    );

  return (
    <MainMonthForm type='coppy' editData={MainInMonth.current} handleCancel={() => navigate(ROUTES.routeChange(''))} />
  );
};
